import { render } from "./AIServiceParameter.vue?vue&type=template&id=9b5d0f2c&scoped=true"
import script from "./AIServiceParameter.vue?vue&type=script&lang=ts"
export * from "./AIServiceParameter.vue?vue&type=script&lang=ts"

import "./AIServiceParameter.vue?vue&type=style&index=0&id=9b5d0f2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b5d0f2c"

export default script